import Edhilson from '../images/reviews/edhilson.jpg';
import Cumbicos from '../images/reviews/cumbicos.jpg';
import Jumbo from '../images/reviews/jumbo.jpg';
import Segovia from '../images/reviews/segovia.jpg';

export const Reviewers = {
	edhilsson: {
		stars: 5,
		review: `Lo mejor de los productos Ecuatorianos en  Newark , y una excelente atención..`,
		name: `Flores Edhilsson`,
		link: `https://www.facebook.com/edison.flores.10/posts/1827397347329265`,
		date: `02/09/2017`,
		image: Edhilson
	},

	cumbicos: {
		stars: 5,
		review: `Muy bonito felicidades sobrina sigue adelante`,
		name: `Paul Cumbicos`,
		link: `https://www.facebook.com/pcumbicos1/posts/1842847992476548`,
		date: `11/21/2014`,
		image: Cumbicos
	},

	jumbo: {
		stars: 5,
		review: `Muy bueno`,
		name: `Angel Jumbo`,
		link: `https://www.facebook.com/angel.jumbo.16/posts/10223033349972990`,
		date: `11/18/2014`,
		image: Jumbo
	},

	segovia: {
		stars: 5,
		review: `Hay, todo, lo, bueno, para, su, comida,`,
		name: `Anjel Segovia`,
		link: `https://www.facebook.com/permalink.php?story_fbid=2159578980997932&id=100008375534315`,
		date: `07/21/2015`,
		image: Segovia
	}
};
